import styled from "styled-components";

export const LogoWrapper = styled.div`
display: flex;
align-items: baseline;
justify-content: flex-start;
`
export const LogoCircle = styled.div`
display: flex;
align-items: center;
justify-content: center;
width: 40px;
height: 40px;
border-radius: 20px;
background-color: yellow;
margin-right: 10px;
`